import React from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment-timezone';
import { AutoResizer } from 'react-base-table';
import EmptyPlaceholder from '@components/common/EmptyPlaceholder';
import { highlightMomentByEvent, removeHighlightByEvent } from '@store/timeline/ui/actions';
import { defaultColumns } from './constants';
import { Wrapper, StyledBaseTable } from './styled';
import { useData } from './hooks/useData';


const SessionTable = ({
  event,
  expand,
  highlightMoment,
  dateRange,
  noDataText,
}: {
  event: string;
  expand: boolean;
  highlightMoment: number | null;
  dateRange: number[];
  noDataText: string;
}) => {
  const dispatch = useDispatch();
  const columns = defaultColumns[event] || [];
  const data = useData(event, dateRange);

  const rowEventHandlers = {
    onClick: (e) => {
      const currentTime = get(e, ['rowData', 'time']);
      if (Array.isArray(currentTime) && highlightMoment !== currentTime[0]) {
        dispatch(highlightMomentByEvent(event, moment(currentTime[0]).valueOf()));
      } else if (!Array.isArray(currentTime) && currentTime !== highlightMoment) {
        dispatch(highlightMomentByEvent(event, moment(currentTime).valueOf()));
      } else {
        dispatch(removeHighlightByEvent(event));
      }
    },
  };

  const activeIndex = React.useMemo(() => {
    if (!highlightMoment) {
      return -1;
    }
    return data.findIndex(row => (
      (Array.isArray(row.time) && row.time[0] === highlightMoment)
        || row.time === highlightMoment
    ));
  }, [data, highlightMoment]);

  const emptyRenderer = React.useCallback(() => <EmptyPlaceholder emptyPlaceholder={noDataText} className="" />, [noDataText]);

  let height = 275;
  if (data.length === 0) {
    height = 180;
  } else if (data.length < 5) {
    height = data.length * 45 + 50;
  }

  return (
    <Wrapper expand={expand} style={{ height: height }}>
      <StyledBaseTable
        activeIndex={activeIndex}
        data={data}
        columns={columns}
        rowHeight={45}
        rowEventHandlers={rowEventHandlers}
        emptyRenderer={emptyRenderer}
        rowKey="time"
      />
    </Wrapper>
  );
};

export default SessionTable;
